export default "__VITE_ASSET__DGuGp$e9__"